import { useState } from "react";

import { AddPrescriptionModal } from "components/AddPrescriptionModal/AddPrescriptionModal";
import { usePaginatedPatientPrescriptions } from "features/medications/hooks/usePaginatedPatientPrescriptions";

import styles from "./Prescriptions.module.css";
import { Table } from "./Table/Table";

export const Prescriptions = ({
  withoutBorder,
  withoutAddPrescription,
  withoutEditPrescription,
  patientId,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState(10);

  const { data, isLoading, isError, refetch } = usePaginatedPatientPrescriptions(
    patientId,
    currentPage,
    searchQuery,
    rows
  );

  const prescriptions = [...(data?.data || [])];
  const totalRecords = data?.totalRecords || 0;

  return (
    <div
      className={withoutBorder ? styles.wrapperWithoutBorder : styles.wrapper}
    >
      <div className={styles.header}>
        <h2 className={styles.title}>Prescriptions</h2>
        {!withoutAddPrescription && <AddPrescriptionModal />}
      </div>
      <Table
        items={prescriptions}
        tableName="prescriptionsTable"
        isLoading={isLoading}
        isError={isError}
        onRetry={refetch}
        withoutEditPrescription={withoutEditPrescription}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        totalRecords={totalRecords}
        rows={rows}
        setRows={setRows}
      />
    </div>
  );
};
